var React = require('react');

function Key12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3.5C12 5.433 10.433 7 8.5 7C8.34101 7 8.1845 6.9894 8.03113 6.96887L7 8H5V10H3V12H0V9L5.03113 3.96887C5.0106 3.8155 5 3.65899 5 3.5C5 1.567 6.567 0 8.5 0C10.433 0 12 1.567 12 3.5ZM9 4C9.55229 4 10 3.55228 10 3C10 2.44772 9.55229 2 9 2C8.44771 2 8 2.44772 8 3C8 3.55228 8.44771 4 9 4Z","fill":"currentColor"}));
}

Key12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Key12;

Key12.default = Key12;
